<template>
  <el-table
    :data="itemsToShow"
    style="border: 2px solid #ebeef5; width: 100%; min-height: 65vh"
    ref="historyTable"
    row-class-name="body-row"
    highlight-current-row
    max-height="65vh"
    @current-change="selectHistory"
  >
    <template v-for="column in tableFormat">
      <el-table-column
        v-if="column.prop"
        :key="column.label"
        :prop="column.prop"
        :label="column.label"
        sortable
        :sort-method="column.sortMethod"
        :min-width="20"
        :filters="column.filterOption"
        :filter-method="column.filterMethod"
        :filter-placement="column.filterPlacement"
      />
    </template>
  </el-table>
</template>
<script>
import { mapState } from "vuex";
export default {
  props: {
    itemsToShow: Array,
    tableFormat: Array,
  },
  data() {
    return {
      timezone:
        process.env.VUE_APP_SERVER_TIMEZONE ||
        Intl.DateTimeFormat().resolvedOptions().timeZone,
    };
  },
  computed: {
    ...mapState([
      "currentTaskName",
      "instanceId",
      "taskId",
      "isUserLoggedIn",
      "environmentId",
    ]),
  },
  methods: {
    selectHistory(row) {
      this.$emit("selectHistory", row);
    },
  },
  mounted() {
    if (this.itemsToShow.length > 0) {
      this.$refs.historyTable.setCurrentRow(this.itemsToShow[0]);
    }
  },
};
</script>
<style scoped>
.card {
  font-size: 14px;
  color: #606266;
}
.el-card :deep(.el-card__header) {
  background-color: #f0f0f0;
  padding: 10px 20px;
}
.el-card :deep(.el-card__body) {
  padding: 10px 20px;
}
</style>